import { render, staticRenderFns } from "./student-dashboard.vue?vue&type=template&id=1108932c&"
import script from "./student-dashboard.vue?vue&type=script&lang=js&"
export * from "./student-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./student-dashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports